import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { permanentRedirect } from "@/lib/legacyRedirects";

/** Gammal offertförfrågan-sida – permanent omdirigering (301). */
export const Route = createFileRoute("/offertforfragan")({
  head: () => seoHead("/offertforfragan"),
  beforeLoad: () => permanentRedirect("/offerter"),
});
